import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getSubGallery } from "../../Service/Api";
import LazyLoad from "react-lazyload";
import { useState } from "react";

function SubGallery() {
  const { _id } = useParams();
  const [index, setIndex] = useState(0);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getSubGallery", _id],
    queryFn: () => getSubGallery(_id),
    enabled: !!_id,
  });

  if (isLoading) {
    return (
      <div className="innersec py-5 text-center">
        <p className="text-muted">Loading gallery...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="innersec py-5 text-center">
        <p className="text-danger">Failed to load gallery: {error.message}</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="innersec py-5 text-center">
        <p className="text-muted">No gallery data found.</p>
      </div>
    );
  }

  return (
    <div className="innersec">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h1>Sub Gallery</h1>
          </div>
        </div>

        {/* 📅 Gallery Info Row */}
        <div className="row tabs-dynamic">
          <div className="col-md-6 col-xl-3">
            <div className="count-val">
              <p>
                <Link to="/galleryinner">
                  <i className="bi bi-arrow-left"></i> Go Back
                </Link>
              </p>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="month-selection">
              <p>
                <span>Event Date:</span>
                {data?.date
                  ? new Date(data.date).toLocaleDateString("en-GB")
                  : "N/A"}
              </p>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="month-selection">
              <p>
                <span>Last Update:</span>
                {data?.updatedAt
                  ? new Date(data.updatedAt).toLocaleDateString("en-GB")
                  : data?.date
                  ? new Date(data.date).toLocaleDateString("en-GB")
                  : "N/A"}
              </p>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="searchBox">
              <p>
                <span>No. Of Photos:</span> {data?.attachments?.length || 0}
              </p>
            </div>
          </div>
        </div>

        {/* 🖼️ Gallery Content */}
        <div className="row">
          <div className="col-md-12">
            <h4 className="gallery-title">{data.title}</h4>
            <p>{data.description}</p>
          </div>

          {data?.attachments?.length > 0 ? (
            data.attachments.map((img, i) => (
              <div
                key={i}
                className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
              >
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href={`https://webapi.entab.info/api/image/${img}`}
                  onClick={() => setIndex(i)}
                >
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src={`https://webapi.entab.info/api/image/${img}`}
                      onClick={() => setIndex(i)}
                      className="img-fluid"
                      alt={data.title || "Sub Gallery"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png";
                      }}
                    />
                  </LazyLoad>
                </a>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <p className="text-muted">No photos available in this gallery.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubGallery;
